import { useTranslation } from '@thoughtspot/i18n';
import { useCallback, useEffect, useState } from 'react';
export const useOrgRequiredError = (required, selectedOrgIds) => {
    const { t } = useTranslation();
    const [orgError, setOrgError] = useState(null);
    useEffect(() => {
        if (selectedOrgIds.size > 0)
            setOrgError(null);
    }, [selectedOrgIds]);
    const resetOrgError = useCallback(() => setOrgError(null), []);
    const validateOrgSelection = useCallback(() => {
        if (required && selectedOrgIds.size === 0) {
            setOrgError(t('adminSection.userManagement.errors.selectAtLeastOneOrg'));
            return false;
        }
        return true;
    }, [required, selectedOrgIds, t]);
    return { orgError, validateOrgSelection, resetOrgError };
};
//# sourceMappingURL=use-org-required-error.js.map